import { render, staticRenderFns } from "./DialogFooter.vue?vue&type=template&id=6b39d664&scoped=true&"
import script from "./DialogFooter.vue?vue&type=script&lang=js&"
export * from "./DialogFooter.vue?vue&type=script&lang=js&"
import style0 from "./DialogFooter.vue?vue&type=style&index=0&id=6b39d664&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39d664",
  null
  
)

export default component.exports